import React from 'react';
import { Button } from '@mui/material';

const OutlinedIconButton = ({ onClick, children }) => {
  return (
    <Button
      variant="outlined"
      color="outlinedLight"
      sx={{ color: 'black', aspectRatio: 1, padding: 0.5, minWidth: 0 }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default OutlinedIconButton;
